import rtk, { _ } from 'rtk'
import { createActionsHook } from 'rtk/react'
import { name, history } from './constants'
const { createActions, createThunks } = rtk(name)

const actions = createActions({
    locationChange: ({ action, location }) => _({ action, location }),
})

const historyApi = createThunks({
    push: (dest, { dispatch, getState }) => {
        let to = dest
        let state = undefined
        if (typeof dest === 'object') {
            to = dest.to
            state = dest.state
        }
        history.push(to, state)
        return { location: history.location }
    },
    replace: (dest, { dispatch, getState }) => {
        let to = dest
        let state = undefined
        if (typeof dest === 'object') {
            to = dest.to
            state = dest.state
        }
        history.replace(to, state)
        return { location: history.location }
    },

    back: (_, { dispatch, getState }) => {
        history.back()
        return { location: history.location }
    },
    forward: (_, { dispatch, getState }) => {
        history.forward()
        return { location: history.location }
    },
    go: ({ delta }, { dispatch, getState }) => {
        history.go(delta)
        return { location: history.location }
    },
})

// RTK-AUTOEXPORT
// ---- actions ---------
export const { locationChange } = actions

export const useActions = createActionsHook(actions)
// ---- thunks ---------
export const { push, replace, back, forward, go } = historyApi

export const useHistoryApi = createActionsHook(historyApi)
